import { createFileRoute } from '@tanstack/react-router';

import { AuditsListPage } from '@/features/audit-workflow/components/AuditsListPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/audit/audits/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.audits'),
  }),
  component: AuditsListRoute,
});

function AuditsListRoute() {
  return <AuditsListPage />;
}
